module.exports = __webpack_public_path__ + "static/media/background-15.c634c82e.jpg";